var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("navigation", { attrs: { pages: _vm.navigation } }),
      _vm._t("default"),
      _vm.current
        ? _c("page", {
            attrs: { page: _vm.current, "hospital-id": _vm.hospitalId },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }